import { axios } from '@/utils/request'

// 查询分类列表
export function getCategoryList(params) {
  return axios({
    url: '/categories',
    method: 'get',
    params: params
  })
}

// 添加分类/修改分类
export function updateCategory(params) {
  return axios({
    url: '/category/save',
    method: 'post',
    data: params
  })
}

// 删除分类
export function deleteCategory(category_id) {
  return axios({
    url: `/category/${category_id}`,
    method: 'delete'
  })
}
